import React from 'react';
import moment from 'moment';

const SynopticTime = ({location}) => {
    const now = moment();
    const location_datetime = moment(location.datetime);
    const diff = now.diff(location_datetime, 'days');

    const time = location_datetime.format('HH');
    const show = (diff <= 1);

    const getItemClassName = value => {
        if (value === time) {
            return 'synoptic-time-item active';
        }

        return 'synoptic-time-item';
    }

    if (!show) {
        return null;
    }

    return (
        <div className="synoptic-time">
            <div className="synoptic-time-row synoptic-time-pointers">
                <div className={getItemClassName('06')}><i className="material-icons">local_shipping</i></div>
                <div className={getItemClassName('07')}><i className="material-icons">local_shipping</i></div>
                <div className={getItemClassName('08')}><i className="material-icons">local_shipping</i></div>
                <div className={getItemClassName('09')}><i className="material-icons">local_shipping</i></div>
                <div className={getItemClassName('10')}><i className="material-icons">local_shipping</i></div>
                <div className={getItemClassName('11')}><i className="material-icons">local_shipping</i></div>
                <div className={getItemClassName('12')}><i className="material-icons">local_shipping</i></div>
                <div className={getItemClassName('13')}><i className="material-icons">local_shipping</i></div>
                <div className={getItemClassName('14')}><i className="material-icons">local_shipping</i></div>
                <div className={getItemClassName('15')}><i className="material-icons">local_shipping</i></div>
                <div className={getItemClassName('16')}><i className="material-icons">local_shipping</i></div>
                <div className={getItemClassName('17')}><i className="material-icons">local_shipping</i></div>
                <div className={getItemClassName('18')}><i className="material-icons">local_shipping</i></div>
            </div>

            <div className="synoptic-time-row synoptic-time-bar"></div>

            <div className="synoptic-time-row synoptic-time-hours">
                <div className="synoptic-time-item">06</div>
                <div className="synoptic-time-item">07</div>
                <div className="synoptic-time-item">08</div>
                <div className="synoptic-time-item">09</div>
                <div className="synoptic-time-item">10</div>
                <div className="synoptic-time-item">11</div>
                <div className="synoptic-time-item">12</div>
                <div className="synoptic-time-item">13</div>
                <div className="synoptic-time-item">14</div>
                <div className="synoptic-time-item">15</div>
                <div className="synoptic-time-item">16</div>
                <div className="synoptic-time-item">17</div>
                <div className="synoptic-time-item">18</div>
            </div>
        </div>
    );

}

export default SynopticTime;



// WEBPACK FOOTER //
// ./src/components/SynopticTime.js